import React from "react";

const defaultTrainingmeasuresData = ["Employees", "Workers"].flatMap((group) =>
  ["Male", "Female", "Total"].map((gender) => ({
    group,
    gender,
    current: {
      total: "",
      health: "",
      healthPercent: "",
      skill: "",
      skillPercent: "",
    },
    previous: {
      total: "",
      health: "",
      healthPercent: "",
      skill: "",
      skillPercent: "",
    },
  }))
);

const TrainingMeasuresTable = ({
  trainingmeasuresdata,
  setTrainingMeasuresData,
}) => {
  const handleChange = (group, gender, period, field, value) => {
    const index = trainingmeasuresdata.findIndex(
      (r) => r.group === group && r.gender === gender
    );
    if (index === -1) return;

    const updated = [...trainingmeasuresdata];
    updated[index][period][field] = value;
    setTrainingMeasuresData(updated);
  };

  const groups = ["Employees", "Workers"];
  const genders = ["Male", "Female", "Total"];

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th rowSpan="3" style={headerStyle}>
              Cetgory
            </th>
            <th colSpan="5" style={headerStyle}>
              FY ____
              <br />
              Current Financial Year
            </th>
            <th colSpan="5" style={headerStyle}>
              FY ____
              <br />
              Previous Financial Year
            </th>
          </tr>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th rowSpan="2" style={headerStyle}>
              Total (A)
            </th>
            <th colSpan="2" style={headerStyle}>
              On health & Safety measures
            </th>
            <th colSpan="2" style={headerStyle}>
              On skill upgradation
            </th>
            <th rowSpan="2" style={headerStyle}>
              Total (D)
            </th>
            <th colSpan="2" style={headerStyle}>
              On health & Safety measures
            </th>
            <th colSpan="2" style={headerStyle}>
              On skill upgradation
            </th>
          </tr>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={headerStyle}>No. (B)</th>
            <th style={headerStyle}>% (B/A)</th>
            <th style={headerStyle}>No. (C)</th>
            <th style={headerStyle}>% (C/A)</th>
            <th style={headerStyle}>No. (E)</th>
            <th style={headerStyle}>% (E/D)</th>
            <th style={headerStyle}>No. (F)</th>
            <th style={headerStyle}>% (F/D)</th>
          </tr>
        </thead>
        <tbody>
          {groups.map((group) => (
            <React.Fragment key={group}>
              <tr>
                <td colSpan="11" style={groupHeaderStyle}>
                  {group}
                </td>
              </tr>
              {genders.map((gender) => {
                const row = trainingmeasuresdata.find(
                  (r) => r.group === group && r.gender === gender
                );
                if (!row) return null;

                return (
                  <tr key={`${group}-${gender}`}>
                    <td style={{ ...cellStyle, fontWeight: "bold" }}>
                      {gender}
                    </td>
                    {/* Current FY */}
                    <td style={cellStyle}>
                      <input
                        type="text"
                        value={row.current.total}
                        onChange={(e) =>
                          handleChange(
                            group,
                            gender,
                            "current",
                            "total",
                            e.target.value
                          )
                        }
                        style={inputStyle}
                        placeholder="Total"
                      />
                    </td>
                    <td style={cellStyle}>
                      <input
                        type="text"
                        value={row.current.health}
                        onChange={(e) =>
                          handleChange(
                            group,
                            gender,
                            "current",
                            "health",
                            e.target.value
                          )
                        }
                        style={inputStyle}
                        placeholder="Details"
                      />
                    </td>
                    <td style={cellStyle}>
                      <input
                        type="text"
                        value={row.current.healthPercent}
                        onChange={(e) =>
                          handleChange(
                            group,
                            gender,
                            "current",
                            "healthPercent",
                            e.target.value
                          )
                        }
                        style={inputStyle}
                        placeholder="Details"
                      />
                    </td>
                    <td style={cellStyle}>
                      <input
                        type="text"
                        value={row.current.skill}
                        onChange={(e) =>
                          handleChange(
                            group,
                            gender,
                            "current",
                            "skill",
                            e.target.value
                          )
                        }
                        style={inputStyle}
                        placeholder="Details"
                      />
                    </td>
                    <td style={cellStyle}>
                      <input
                        type="text"
                        value={row.current.skillPercent}
                        onChange={(e) =>
                          handleChange(
                            group,
                            gender,
                            "current",
                            "skillPercent",
                            e.target.value
                          )
                        }
                        style={inputStyle}
                        placeholder="Details"
                      />
                    </td>

                    {/* Previous FY */}
                    <td style={cellStyle}>
                      <input
                        type="text"
                        value={row.previous.total}
                        onChange={(e) =>
                          handleChange(
                            group,
                            gender,
                            "previous",
                            "total",
                            e.target.value
                          )
                        }
                        style={inputStyle}
                        placeholder="Total"
                      />
                    </td>
                    <td style={cellStyle}>
                      <input
                        type="text"
                        value={row.previous.health}
                        onChange={(e) =>
                          handleChange(
                            group,
                            gender,
                            "previous",
                            "health",
                            e.target.value
                          )
                        }
                        style={inputStyle}
                        placeholder="Details"
                      />
                    </td>
                    <td style={cellStyle}>
                      <input
                        type="text"
                        value={row.previous.healthPercent}
                        onChange={(e) =>
                          handleChange(
                            group,
                            gender,
                            "previous",
                            "healthPercent",
                            e.target.value
                          )
                        }
                        style={inputStyle}
                        placeholder="Details"
                      />
                    </td>
                    <td style={cellStyle}>
                      <input
                        type="text"
                        value={row.previous.skill}
                        onChange={(e) =>
                          handleChange(
                            group,
                            gender,
                            "previous",
                            "skill",
                            e.target.value
                          )
                        }
                        style={inputStyle}
                        placeholder="Details"
                      />
                    </td>
                    <td style={cellStyle}>
                      <input
                        type="text"
                        value={row.previous.skillPercent}
                        onChange={(e) =>
                          handleChange(
                            group,
                            gender,
                            "previous",
                            "skillPercent",
                            e.target.value
                          )
                        }
                        style={inputStyle}
                        placeholder="Details"
                      />
                    </td>
                  </tr>
                );
              })}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const headerStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
  width: "6%",
  wordWrap: "break-word",
};

const groupHeaderStyle = {
  padding: "10px",
  backgroundColor: "#e7dfe2",
  fontWeight: "bold",
  border: "1px solid #000",
  textAlign: "center",
};

const cellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
  width: "6%",
};

const inputStyle = {
  width: "100%",
  padding: "8px 10px",
  fontSize: "14px",
  borderRadius: "4px",
  border: "1px solid grey",
  outline: "none",
  boxSizing: "border-box",
};

export default TrainingMeasuresTable;
